'use client';

import { SpotMarketConfig } from '@velocity-exchange/sdk';
import React from 'react';
import Button from 'src/components/primitives/Button/Button';
import ResponsiveModal from 'src/components/Modals/ResponsiveModal/ResponsiveModal';
import StakeFormContent from 'src/components/Staking/StakeFormContent';
import useStakeForm from 'src/components/Staking/hooks/useStakeForm';

interface Props {
	onConfirm: () => void;
	isDriftStaking: boolean | undefined;
	selectedIfStakeMarket: SpotMarketConfig;
}

const StakeModalContent = ({
	onConfirm,
	isDriftStaking,
	selectedIfStakeMarket: defaultSelectedMarket,
}: Props) => {
	const {
		isSubmitDisabled,
		isSubmitting,
		handleSubmit,
		submitButtonContent,
		...stakeFormProps
	} = useStakeForm({
		isDriftStaking,
		defaultSelectedMarket,
		onConfirm,
	});

	return (
		<>
			<ResponsiveModal.Body>
				<StakeFormContent
					isDriftStaking={isDriftStaking}
					isSubmitting={isSubmitting}
					{...stakeFormProps}
				/>
			</ResponsiveModal.Body>
			<ResponsiveModal.Footer>
				<Button
					size="md"
					className="w-full"
					disabled={isSubmitDisabled}
					isLoading={isSubmitting}
					onClick={handleSubmit}
				>
					{submitButtonContent}
				</Button>
			</ResponsiveModal.Footer>
		</>
	);
};

export default React.memo(StakeModalContent);
